// extracted by mini-css-extract-plugin
module.exports = {"page":"StartPage_page__23RTr","welcomeSegment":"StartPage_welcomeSegment__an3fm"};